"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockFactory = void 0;
const blockwise_1 = require("./index");
/**
 * Helper class to generate blocks.
 *
 * @includeExample ./src/block-factory.example.ts
 */
class BlockFactory {
    constructor() {
        this.block = blockwise_1.UNIT_BLOCK;
    }
    randomize(min = 0, max = 100) {
        this.block = {
            x: Math.random() * (max - min) + min,
            y: Math.random() * (max - min) + min,
            w: Math.random() * (max - min) + min,
            h: Math.random() * (max - min) + min
        };
        return this;
    }
    build() {
        return Object.assign({}, this.block);
    }
}
exports.BlockFactory = BlockFactory;
